module.exports = __webpack_public_path__ + "img/JOC_3662.cb76cd60.jpg";